import { Route, Routes } from 'react-router-dom';
import { ExperienceDetailPage } from '../pages/experiencies/ExperienceDetailPage';
import { ExperienceDetailPage2 } from '../pages/experiencies/ExperienceDetailPage2';
import { ExperiencesMainPage } from '../pages/experiencies/ExperiencesMainPage';

export const ExperienciesRouter = () => {


    return (
        <Routes>

            <Route path='/' element={<ExperiencesMainPage />} />
            <Route path='/detail' element={<ExperienceDetailPage />} />
            <Route path='/detail2' element={<ExperienceDetailPage2 />} />
        </Routes>
    );
};
